import React from 'react';
import styled from 'styled-components';

const ColorsStyle = styled.div`
	.colors {
		display: flex;
		flex-wrap: wrap;
	}
	.color {
		width: 100px;
		height: 100px;
		.color-example {
			width: 50px;
			height: 50px;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;
const colors = [
	{ name: 'DCBLOX_Red', color: '#f23722' },
	{ name: 'DCBLOX_Purple', color: '#583a6b' },
	{ name: 'DCBLOX_Black', color: '#000000' },
	{ name: 'DCBLOX_Gray', color: '#5b595b' },
	{ name: 'DCBLOX_White', color: '#efeeed' },
	{ name: 'DCBLOX_Aqua', color: '#79d2de' },
	{ name: 'DCBLOX_Lime', color: '#b5d334' },
	{ name: 'DCBLOX_Orange', color: '#fcaf17' },
	{ name: 'Footer_Black', color: '#262627' },
	{ name: 'Med_Lime', color: '#a8ad00' },
	{ name: 'Dark_Lime', color: '#949300' },
	{ name: 'Med_Rust', color: '#df6a2e' },
	{ name: 'Bright_Rust', color: '#f58145' },
	{ name: 'Dark_Rust', color: '#af5222' },
	{ name: 'Bright_Blue', color: '#3192f4' },
	{ name: 'Blue', color: '#2a7de1' },
	{ name: 'Dark_Blue', color: '#416ba9' },
	{ name: 'Bright_Purple', color: '#a46cf4' },
	{ name: 'Purple', color: '#9164cc' },
	{ name: 'Dark_Purple', color: '#8060a9' },
	{ name: 'Extra_Dark_Purple', color: '#432c52' },
	{ name: 'Bright_Emerald', color: '#00b0b9' },
	{ name: 'Emerald', color: '#008388' },
	{ name: 'Dark_Emerald', color: '#007377' },
	{ name: 'Cool_Gray_Dark_1', color: '#323e48' },
	{ name: 'Cool_Gray_Dark_2', color: '#5b6670' },
	{ name: 'Cool_Gray_Dark_3', color: '#7b868c' },
	{ name: 'Cool_Gray_Med_1', color: '#a2a9ad' },
	{ name: 'Cool_Gray_Med_2', color: '#c1c5c8' },
	{ name: 'Cool_Gray_Med_3', color: '#cfd2d3' },
	{ name: 'Cool_Gray_Light_1', color: '#d4d7d8' },
	{ name: 'Cool_Gray_Light_2', color: '#dfe1e1' },
	{ name: 'Cool_Gray_Light_3', color: '#edefef' },
	{ name: 'Warm_Gray_Dark_1', color: '#24272a' },
	{ name: 'Warm_Gray_Dark_2', color: '#53575a' },
	{ name: 'Warm_Gray_Dark_3', color: '#6f7271' },
	{ name: 'Warm_Gray_Med_1', color: '#888b8d' },
	{ name: 'Warm_Gray_Med_2', color: '#9ea1a2' },
	{ name: 'Warm_Gray_Med_3', color: '#b0b3b2' },
	{ name: 'Warm_Gray_Light_1', color: '#c8c8c8' },
	{ name: 'Warm_Gray_Light_2', color: '#dedede' },
	{ name: 'Warm_Gray_Light_3', color: '#eeeeee' },
	{ name: 'White', color: '#ffffff' },
];

export const Colors = () => {
	return (
		<ColorsStyle>
			<div className='colors'>
				{colors &&
					colors.map(color => (
						<div className='color'>
							<div className='color-name labels21'>{color?.name}</div>
							<div className='color-example' style={{ background: color?.color }}></div>
						</div>
					))}
			</div>
		</ColorsStyle>
	);
};
